import { Box, Typography, Button, Stack } from '@mui/material'
import Panel from './common/Panel'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded'
import { SP, FS, CONTENT_WIDTH } from '../theme/tokens'

/**
 * 404 — Route not found.
 *
 * Rendered by the catch-all <Route path="*"> in App.js. Shows the failed path,
 * a short explanation, and two CTAs to the most common destinations (home +
 * after-sales). Replaces the previous silent redirect to /overview, which hid
 * broken links and made drift hard to notice.
 */
export default function NotFound() {
  const loc = useLocation()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        p: SP.section,
      }}
    >
      {/* 🔴 G0b.5 (2026-10-13): Literal 520 → `CONTENT_WIDTH.panel`. Der Wert
          BLEIBT (`inhaltsbreite.md` §5.1:667, §2.1 WF6:263) — er wird nur
          benannt, nicht geaendert (Plan §6.2 Ziff. 6: die drei Literal-Deckel
          1200/1100/520 werden Token-Aufrufer). */}
      <Panel pad="md" sx={{ maxWidth: CONTENT_WIDTH.panel, textAlign: 'center' }}>
        <Stack spacing={SP.section} alignItems="center">
          <Typography
            component="div"
            sx={{ fontSize: 96, fontWeight: 700, lineHeight: 1, color: 'primary.main', letterSpacing: '-0.05em' }}
          >
            404
          </Typography>
          <Stack spacing={1} alignItems="center">
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Page not found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              No route in Forge matches this URL. It may have been renamed, or the link is stale.
            </Typography>
          </Stack>
          <Box
            sx={{
              px: 1.5,
              py: 0.75,
              borderRadius: 1,
              bgcolor: 'action.hover',
              fontSize: FS.sm,
              fontFamily: 'monospace',
              color: 'text.secondary',
              wordBreak: 'break-all',
              maxWidth: '100%',
            }}
          >
            {loc.pathname}
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ pt: 1 }}>
            <Button
              component={RouterLink}
              to="/overview"
              variant="contained"
              startIcon={<HomeRoundedIcon />}
            >
              Back to overview
            </Button>
            <Button
              component={RouterLink}
              to="/rma"
              variant="outlined"
              startIcon={<SupportAgentRoundedIcon />}
            >
              After-Sales
            </Button>
          </Stack>
        </Stack>
      </Panel>
    </Box>
  )
}
